import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import {
  Row,
  Col,
  Table,
  Button,
} from 'reactstrap';
import { fetchProductsInitAction } from '../../../../../actions/instances/products';
import Icon from '../../../../atoms/Icon/Icon';
import './SelectProductModal.scss';

const SelectProductModal = ({
  onItemSelected,
}) => {
  const {
    products,
    didLoadProducts,
    isLoadingProducts,
  } = useSelector(state => state.products);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!didLoadProducts && !isLoadingProducts) {
      dispatch(fetchProductsInitAction());
    }
  }, []);
  return (
    <div>
      <Row>
        <Col md={12}>
          <Table responsive striped bordered>
            <colgroup>
              <col width="10%" />
              <col width="60%" />
              <col width="20%" />
              <col width="10%" />
            </colgroup>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Dynasty</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {products.map(product => (
                <tr>
                  <td>{product.code}</td>
                  <td>{`${product.name} [${product.code}]`}</td>
                  <td>{`${product.dynasty.name} [${product.dynasty.code}]`}</td>
                  <td className="text-center">
                    <Button size="sm" color="light" onClick={() => onItemSelected(product)}>
                      <Icon icon="check" color="#000" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  );
};

SelectProductModal.propTypes = {
  onItemSelected: PropTypes.func.isRequired,
};

SelectProductModal.defaultProps = {

};

export default SelectProductModal;
